export default "__VITE_ASSET__yi6W2kho__"